import { LeasingProjects } from "./leasingprojects";
import { LeasingMap } from "./map";
import { Vehiclesbyyeartable } from "./Vehiclesbyyeartable";
import {
    // useGetLeasingDataQuery,
    useGetLeasingThreeYearDataQuery,
    useGetLeasingFinancingDataQuery,
    useGetTransportbyRegionQuery,
    useGetTransportTypesCountQuery,
    useGetLeasingRegionalQuery
} from "./api";
import { useState, useCallback } from "react";
import { Button } from "antd";
import { Totalleasingtable } from "./Totalleasingtable";
import { useGetTerritorialUnitsGetpolygonsListQuery } from "../../../redux/api/handBooksApi/territorialUnitsApi";
import ReportDepartmentMechModal from "../../../pages/admin/mechanization/reportDepartmentMech/ReportDepartmentMechModal";
import { useGetReportByLeasingMutation } from "../../../redux/api/mechanization/reportDepartmentMechApi";
import { EntTerritorialUnitsFilter } from "../../../models/filters/territorialUnitsFilter";
import { LeasingByRegion } from "./leasingbyregion";
import style from './style.module.css';
import { PreloaderSvg } from "../../preloaderSvg/PreloaderSvg";
import { useTranslation } from "react-i18next";

export const Leasing = () => {
    const { t } = useTranslation();
    const [selectedYear, setSelectedYear] = useState<number | null>(2025);
    const [selectedMapYear, setSelectedMapYear] = useState<number | null>(2025);
    const [selectedRegionId, setSelectedRegionId] = useState<number>(2067);
    const [selectedRegionName, setSelectedRegionName] = useState<string>("Чуйская область");
    const [showReportModal, setShowReportModal] = useState<boolean>(false);
    const [getLeasingReport] = useGetReportByLeasingMutation();

    const { data: leasingThreeYearData, isLoading: isLoadingThreeYear } = useGetLeasingThreeYearDataQuery();
    const { data: financingData, isLoading: isLoadingFinancing } = useGetLeasingFinancingDataQuery(selectedYear?.toString() || '');
    const { data: transportTypes, isLoading: isLoadingTypes } = useGetTransportbyRegionQuery({
        year: selectedMapYear ? selectedMapYear.toString() : undefined,
        territorialUnitId: selectedRegionId
    });
    const { data: defaultTransportTypes, isLoading: isLoadingDefaultTypes } = useGetTransportTypesCountQuery(selectedMapYear || 2025);
    const { data: regionalData, isLoading: isLoadingRegional } = useGetLeasingRegionalQuery(selectedYear?.toString());
    const { data: polygonsData, isLoading: polygonsLoading } = useGetTerritorialUnitsGetpolygonsListQuery(new EntTerritorialUnitsFilter({ page: 1, size: 15 }));

    const handleRegionClick = useCallback((regionId: number, regionName: string) => {
        setSelectedRegionId(regionId);
        setSelectedRegionName(regionName);
    }, []);

    const isLoading = isLoadingThreeYear || isLoadingFinancing || isLoadingTypes ||
        isLoadingDefaultTypes || isLoadingRegional || polygonsLoading;

    const getReport = async (payload: { years?: number[]; languageEnum: string }): Promise<Blob> => {
        return await getLeasingReport(payload).unwrap();
    };

    const polygonsFilter = new EntTerritorialUnitsFilter({
        page: 1,
        size: 15
    });

    const handleYearChange = (year: number | null) => {
        if (year) {
            setSelectedYear(year);
        }
    };

    const handleMapYearChange = (year: number | null) => {
        setSelectedMapYear(year);
    };

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <PreloaderSvg />
            </div>
        );
    }

    return (
        <div className={style.container}>
            <div className={style.title}>
                <div className={style.title_header}>
                    <h1>{t('Leasing of machinery')}</h1>
                    <Button style={{ marginLeft: '5px' }} type="primary" icon={<img src="../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />} onClick={() => setShowReportModal(true)}>
                        {t('general.generate_report')}
                    </Button>
                    <ReportDepartmentMechModal
                        type={'leasing'}
                        title={t('reports.report_by_leasing')}
                        getReport={getReport}

                        show={showReportModal}
                        onHide={() => setShowReportModal(false)}
                    />
                </div>
                <div className={style.title_inner}>
                    <img src="./homeicon.svg" alt="home" />
                    <p>{t('Home')}</p>
                    <img src="./arrowright.svg" alt="arrow" />
                    <p>{t('Mechanization and innovations')}</p>
                    <img src="./arrowright.svg" alt="arrow" />
                    <span className={style.namepage}>{t('Leasing of machinery')}</span>
                </div>
            </div>
            <div className={style.map_table}>
                <Totalleasingtable
                    transportTypes={defaultTransportTypes?.res}
                    isLoading={isLoadingDefaultTypes}
                    selectedYear={selectedMapYear}
                />
                <LeasingMap
                    latitude={41.5089324}
                    longitude={74.724091}
                    polygonsData={polygonsData}
                    transportTypes={transportTypes}
                    isLoading={isLoadingTypes}
                    onRegionClick={handleRegionClick}
                    selectedRegionName={selectedRegionName}
                    selectedYear={selectedMapYear}
                    onYearChange={handleMapYearChange}
                    initialRegionId={selectedRegionId}
                />
            </div>
            <LeasingByRegion
                data={regionalData}
                isLoading={isLoadingRegional}
                selectedYear={selectedYear}
                onYearChange={handleYearChange}
            />
            <Vehiclesbyyeartable
                data={leasingThreeYearData}
                isLoading={isLoadingThreeYear}
            />

            <LeasingProjects
                data={financingData?.res}
                isLoading={isLoadingFinancing}
                selectedYear={selectedYear}
                onYearChange={handleYearChange}
            />
        </div>
    );
};